export default "__VITE_ASSET__BA3sBQI8__"